// extracted by mini-css-extract-plugin
export default {"cookies":"styles_cookies__-e5h1","dNone":"styles_dNone__ScEC6","o1":"styles_o1__rajpx"};